import * as Phaser from "phaser";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";

export class NameIndicator extends Phaser.GameObjects.Container {
  private text: Phaser.GameObjects.Text;

  constructor(private myScene: BasicScene, x: number, y: number) {
    super(myScene, x, y);

    this.text = myScene.add.text(0, 0, `${this.myScene.storage.pet().name}`, {
      fontSize: "24px",
      fontStyle: "normal",
      fontFamily: "Phantom-Muff",
      color: "#" +
        this.myScene.global.TUNER_TWA_CONFIG.palette.text.toString(16),
    })
      .setOrigin(1, 0.5);

    this.add(this.text);
  }
}
